import LogoPJeSimbolo from '@/img/LogoPJeSimbolo';
import PropTypes from 'prop-types';
import { Component } from 'react';
import Configuracao from '../util/Configuracao';

class IconeOrigem extends Component {
    render() {
        if (!this.props.processo) {
            return null;
        }

        if (this.props.processo.origem && this.props.processo.origem === Configuracao.ORIGEM_PJE) {
            return (
                <LogoPJeSimbolo
                    transform="scale(1.8)"
                    alt={'Processo do PJe'}
                />
            );
        }

        return null;
    }
}

IconeOrigem.propTypes = {
    processo: PropTypes.object.isRequired
};

export default IconeOrigem;
